import { useEffect, useState } from "react";
import { post } from "../networking/RequestService";

const useListDealsByProfileId = (profileId) => {
    const [deals, setDeals] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const fetchDeals = async () => {
        if (!profileId) return;

        setLoading(true);
        setError(null);
        try {
            const res = await post({
                fn: "listDealsByProfileId",
                profileId,
            });

            setDeals(res.data.deals || []);
        } catch (err) {
            setError(err);
            setDeals([]);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchDeals();
    }, [profileId]);

    return { deals, loading, error, refetch: fetchDeals };
};

export default useListDealsByProfileId;
